import Api from '@api/xiao_xiong/marketing'
import noticeStore from '@components/LocalMerchant/NoticeChat/store'
import { BOND_PATH_A, MARKETING_CENTER_PATH } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { HLJ_STATISTIC } from '@util'
import { action, observable } from 'mobx'

export default class Store {
  @observable detail = {}
  @observable is_play = true
  @observable merchant_use_list = []
  @observable coupon = {}
  @observable pay_money = {}
  @observable video = {}
  @observable loading = true

  getDetail = async () => {
    const { data, success } = await Api.getProData()
    this.loading = false
    if (success) {
      this.detail = data.merchant || {}
      this.merchant_use_list = data.merchant_use_list || []
      this.coupon = data.coupon || {}
      this.pay_money = data.pay_money || {}
      this.video = data.video || {}
      if (!isUltimate()) {
        noticeStore.setBottom('120px')
      }
    }
  }

  @action
  init = () => {
    this.getDetail()
  }

  //旗舰版跳转到支付页面
  bookService = (title, fee, type) => () => {
    HLJ_STATISTIC({
      element_tag: `${type}_submit`
    })

    if (!fee) {
      return
    }
    window.location.href =
      '#/localMerchant/cashier?payType=2&price=' +
      fee +
      '&title=' +
      title +
      '&product_id=50' +
      '&apiName=/p/wedding/index.php/admin/APIMerchantPro/pay&return_url=' +
      MARKETING_CENTER_PATH
  }

  renew = (product_id, fee) => () => {
    this.bookService('店铺开通商家服务', fee)() //开通旗舰版
  }

  bookBind = () => {
    //保证金支付跳转的页面
    window.location.href = BOND_PATH_A
  }

  @action
  changePlayStatus = status => {
    this.is_play = status
  }

  @observable video_modal = false

  changeVideoModal = flag => () => {
    this.video_modal = flag
  }
}
